import { render } from "./ChoseSubTop.vue?vue&type=template&id=8c1c4b60&scoped=true"
import script from "./ChoseSubTop.vue?vue&type=script&lang=js"
export * from "./ChoseSubTop.vue?vue&type=script&lang=js"

import "./ChoseSubTop.vue?vue&type=style&index=0&id=8c1c4b60&scoped=true&lang=css"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-8c1c4b60"]])

export default __exports__